import React, { useRef } from "react";
import styles from "./InteractiveContentModal.module.scss";
import { appConfig } from "../../config";

const InteractiveContentModal = ({ closeModal }) => {
  const iframe = useRef(null);
  return (
    <div className={styles.modal}>
      <span onClick={closeModal} className={styles.close}>
        <img
          src={process.env.PUBLIC_URL + "/images/toggle.svg"}
          alt="Toggle Icon"
          srcSet=""
        />
      </span>
      <iframe
        id="fridge content"
        ref={iframe}
        style={{ height: "100%", width: "100%", overflow: "hidden", border: "none" }}
        allowFullScreen={false}
        title="Fridge Content"
        src={appConfig.interactiveContent}
      ></iframe>
    </div>
  );
};

export { InteractiveContentModal };
